module.exports = __webpack_public_path__ + "e4db039be5aaea5c933a8069cacc77e6.mp4";


//////////////////
// WEBPACK FOOTER
// ./apps/www.dawnofwar.com/src/static/video/spinnin-klaw.mp4
// module id = 649
// module chunks = 0